import React, { Component } from 'react';
import { useRefJs } from '@platform/api';
import { loadJS } from '../../../core/api/loadJS';
const componentName = "business_component/print/print/main/index";
const url = "../../../../platform/resource/business_component/print/print/main/index.js";
useRefJs.setConfig({ [componentName]: url });

let PrintOutputModal = useRefJs([componentName], function (Poc) {
    class PrintOutputModal extends Component {
        constructor(props) {
            super(props);
        }
        render() {
            const { forwardedRef, ...rest } = this.props;
            return <Poc.PrintOutputModal ref={forwardedRef} {...rest} />
        }
    }
    return {
        PrintOutputModal: React.forwardRef((props, ref) => {
            return <PrintOutputModal {...props} forwardedRef={ref} />;
        }),
    }
});
export default PrintOutputModal;

let output = (...args) => {
    loadJS(url, () => {
        let res = window[componentName].default || window[componentName];
        res.output(...args);
    })
}
export { PrintOutputModal, output };